import { render, staticRenderFns } from "./mailEdit.vue?vue&type=template&id=2808c893&scoped=true&"
import script from "./mailEdit.vue?vue&type=script&lang=js&"
export * from "./mailEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailEdit.vue?vue&type=style&index=0&id=2808c893&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808c893",
  null
  
)

export default component.exports